/**
 * Get the current backend version to check whether the app has been updated.
 *
 * @returns {*} response with current backend version
 */
export const fetchCurrentBackendVersion = () => {
    return fetch(`/api/utility/version`, {
        method: 'get'
    })
    .then(function (response) {
        return response.json()
    })
    .then(function (data) {
        return data
    })
}

/**
 * Call to a third-party service to determine a client' country by IP
 *
 * @returns {*} response with client's country
 */
export const fetchClientCountry = () => {
    return fetch(`https://api.country.is`, {
        method: 'get'
    })
    .then(function (response) {
        return response.json()
    })
    .then(function (data) {
        return data
    })
}